/* eslint-disable max-len */
/* eslint-disable no-useless-constructor */
import * as utility from '../../utils/utility';
import RecipeContent from './RecipeContent';

export default class JsonRecipeContent extends RecipeContent {
	constructor(recipe) {
		super(recipe);
	}

	getAuthor() {
		const { authors } = this.recipe.additionalDetails;
		return authors?.[0]?.title ? utility.wrapWithQuotes(authors?.[0]?.title) : utility.wrapWithQuotes('Flavour Network');
	}

	getDesription() {
		let description = this.recipe.content;

		if (description) {
			description = utility.removeHtmlTags(description);
			description = utility.findAndReplaceInString(description, /\n/g, '');// remove line breaks
			description = utility.findAndReplaceInString(description, '&nbsp;', ' ');// remove nbsp
			return utility.wrapWithQuotes(description);
		}

		return null;
	}

	getPrepTime() {
		const prepTimeHours = parseInt(this.recipe.recipeDetails?.recipeDetailTimesGroup?.recipeDetailPrepTimeGroup?.recipeDetailPrepTimeHours || 0, 10);
		const prepTimeMinutes = parseInt(this.recipe.recipeDetails?.recipeDetailTimesGroup?.recipeDetailPrepTimeGroup?.recipeDetailPrepTimeMinutes || 0, 10);

		return (prepTimeHours * 60) + prepTimeMinutes;
	}

	getCookTime() {
		const cookTimeHours = parseInt(this.recipe.recipeDetails?.recipeDetailTimesGroup?.recipeDetailCookTimeGroup?.recipeDetailCookTimeHours || 0, 10);
		const cookTimeMinutes = parseInt(this.recipe.recipeDetails?.recipeDetailTimesGroup?.recipeDetailCookTimeGroup?.recipeDetailCookTimeMinutes || 0, 10);

		return (cookTimeHours * 60) + cookTimeMinutes;
	}

	getTotalTime() {
		return this.getPrepTime() + this.getCookTime();
	}

	// eslint-disable-next-line class-methods-use-this
	convertTimeToHoursAndMin(timeInMinutes) {
		if (timeInMinutes > 0) {
			const hours = (timeInMinutes / 60);
			const rhours = Math.floor(hours);
			const minutes = (hours - rhours) * 60;
			const rminutes = Math.round(minutes);

			if (rhours && rminutes) {
				return `${rhours}h ${rminutes} min`;
			} if (rhours) {
				return `${rhours}h`;
			} if (rminutes) {
				return `${rminutes} min`;
			}
		}
		return null;
	}

	// At the moment we are setting the category as a tag
	getRecipeCategory() {
		const tags = this.recipe.tags?.nodes;

		if (utility.arrayHasItems(tags)) {
			const category = tags.map((tag) => tag.name).join();
			return utility.wrapWithQuotes(category);
		}

		return null;
	}

	// Return recipe cuisine
	getRecipeCuisine() {
		const cuisines = this.recipe.recipeCuisines?.nodes;
		if (utility.arrayHasItems(cuisines)) {
			const cuisine = cuisines.map((item) => item.name).join();
			return utility.wrapWithQuotes(cuisine);
		}

		return null;
	}

	// Return comma seperated string of ingrediants
	getIngredients() {
		const ingrediantSections = this.recipe.subRecipes?.subRecipeRepeater;

		const ingredientsArry = [];

		if (utility.arrayHasItems(ingrediantSections)) {
			ingrediantSections.forEach((section) => {
				if (utility.arrayHasItems(section.subRecipeIngredientRepeater)) {
					section.subRecipeIngredientRepeater.forEach((ingredient) => {
						if (ingredient.subRecipeIngredientName) {
							ingredientsArry.push(utility.wrapWithQuotes(utility.findAndReplaceInString(ingredient.subRecipeIngredientName.trim(), '"', '&quot;')));
						}
					});
				}
			});
		}

		return ingredientsArry ? ingredientsArry.join() : null;
	}

	getYield() {
		return this.recipe.recipeDetails.recipeDetailYield
			? utility.wrapWithQuotes(this.recipe.recipeDetails.recipeDetailYield)
			: null;
	}

	convertPrepStepsToJsonLdArry(pageUrl) {
		const prepSteps = this.getPrepSteps();

		if (prepSteps === null) {
			return null;
		}

		const instructionSteps = prepSteps.map((step, index) => {
			const name = `Step - ${parseInt(index, 10) + 1}`;
			const anchorSectionUrl = this.getPageSectionAnchor(pageUrl, index + 1, '#step');
			const imageUrl = step.recipeDetailPreparationImage ? utility.wrapWithQuotes(step.recipeDetailPreparationImage.mediaItemUrl) : null;

			let prep = step.recipeDetailPreparationStep.trim();
			prep = utility.removeHtmlTags(prep);
			prep = utility.findAndReplaceInString(prep, /\n/g, '');// remove line breaks
			prep = utility.findAndReplaceInString(prep, '&nbsp;', '');// remove nbsp

			return `{
				"@type": "HowToStep",
				"name": "${name}",
				"text": "${prep}",
				"url": "${anchorSectionUrl}",
				"image": ${imageUrl}
			}`;
		});

		return instructionSteps;
	}

	// eslint-disable-next-line class-methods-use-this
	getPageSectionAnchor(pagePath, sectionNumber, anchorPrefix) {
		return pagePath ? `${pagePath}${anchorPrefix}${sectionNumber}` : null;
	}

	convertImageToJsonLdArry() {
		const image = this.getImage();
		return image ? `[${utility.wrapWithQuotes(image)}]` : null;
	}

	// eslint-disable-next-line class-methods-use-this
	wrapWithTimeQuotes(time) {
		return time ? utility.wrapWithQuotes('PT'.concat(time).concat('M')) : null;
	}

	getAggregateRating() {
		if (this.getTotalRatings() > 0) {
			const averageRating = utility.wrapWithQuotes(this.getAverageRating());
			const numVotes = utility.wrapWithQuotes(this.getNumVotes());

			return `{
				"@type": "AggregateRating",
				"ratingValue": ${averageRating},
				"ratingCount": ${numVotes},
				"bestRating": 5
			}`;
		}

		return null;
	}
}
